module.exports = __webpack_public_path__ + "static/media/arrow-blue.515fd911.svg";